import { render, staticRenderFns } from "./EditarPreciosProductosFormComponent.vue?vue&type=template&id=3bb7d49c&"
import script from "./EditarPreciosProductosFormComponent.vue?vue&type=script&lang=js&"
export * from "./EditarPreciosProductosFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports